import { ClientSideDataGridModel } from "src/components/common/dataGrid/gridModel/ClientSideDataGridModel.tsx";
import { AavoDataGrid } from "src/components/common/dataGrid/AavoDataGrid.tsx";
import { enumColumn, floatColumn, integerColumn, textColumn } from "src/components/common/dataGrid/columns.tsx";
import i18n from "i18next";
import { ShopOrderAggregatedSourcesDataGridApi } from "src/api/generated/erp/production/api/shopOrder/shopOrderAggregatedSourcesDataGridApi.ts";
import { ShopOrderAggregatedSourceView } from "src/api/generated/erp/db/types/tables/shopOrderAggregatedSourceView.ts";
import { OpenShopOrderButton } from "src/components/views/erp/utilComponents/OpenShopOrderButton.tsx";
import { getShopOrderAggregatedSourceSourceTypeLabels } from "../../../../../api/generated/erp/db/types/enums/shopOrderAggregatedSourceSourceType.ts";
import { OpenProjectActivityButton } from "../../utilComponents/OpenProjectActivityButton.tsx";
import { OpenCustomerOrderButton } from "../../utilComponents/OpenCustomerOrderButton.tsx";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface ShopOrderAggregatedSourcesDataGridProps {
	shopOrderId: number;
}

export const ShopOrderAggregatedSourcesDataGrid = ({ shopOrderId }: ShopOrderAggregatedSourcesDataGridProps) => {
	return (
		<ClientSideDataGridModel
			fetchData={() =>
				ShopOrderAggregatedSourcesDataGridApi.getData({
					shopOrderId: shopOrderId,
				})
			}
			initialParams={{}}
			getRows={(response) => response}
			getRowId={(row) => row.shopOrderAggregatedSourceId}
			gridId={"3A7B9E2C5F8D41A6"}
			render={({ dataGridProps }) => (
				<AavoDataGrid<ShopOrderAggregatedSourceView>
					columns={[
						enumColumn({
							field: "sourceType",
							headerName: i18n.t("source"),
							enumLabels: getShopOrderAggregatedSourceSourceTypeLabels(),
							width: 150,
						}),
						integerColumn({
							field: "sourceId",
							headerName: i18n.t("source_id"),
						}),
						textColumn({
							field: "sourceDescription",
							headerName: i18n.t("description"),
							width: 150,
						}),
						floatColumn({
							field: "orderedQuantityInBaseUnit",
							headerName: i18n.t("ordered_quantity"),
							width: 120,
						}),
						floatColumn({
							field: "reservedQuantityInBaseUnit",
							headerName: i18n.t("reserved_quantity"),
							width: 120,
						}),
						textColumn({
							field: "sourceShopOrderBatchName",
							headerName: i18n.t("production_batch"),
							width: 150,
						}),
					]}
					disableMultipleRowSelection
					rowContextMenuComponents={({ row }) => [
						row.sourceCustomerOrderId != null && (
							<OpenCustomerOrderButton
								key={"openCustomerOrder"}
								customerOrderId={row.sourceCustomerOrderId}
							/>
						),
						row.sourceActivityId != null && (
							<OpenProjectActivityButton key={"openActivity"} projectActivityId={row.sourceActivityId} />
						),
						row.sourceShopOrderId != null && (
							<OpenShopOrderButton key={"openShopOrder"} shopOrderId={row.sourceShopOrderId} />
						),
					]}
					agentContext={{
						key: defineAgentUiContextKey("erp.production.shopOrderAggregatedSources.grid"),
						data: { shopOrderId },
						rowFields: ["shopOrderAggregatedSourceId", "sourceType", "sourceId"],
						selectedRowPathSegment: (row) => `${i18n.t("source")} ${row.sourceId}`,
					}}
					{...dataGridProps}
				/>
			)}
		/>
	);
};
